import { SubscriptionPlan } from '@repo/graphql-types'

export const CF_ALL_ACCESS_MONTHLY_PRICE_USD = 9
export const CF_ALL_ACCESS_MONTHLY_PRICE_OTHER = 8.99
export const CF_ALL_ACCESS_YEARLY_PRICE = 59.88
// oxlint-disable-next-line unicorn/no-zero-fractions
export const CF_ALL_ACCESS_YEARLY_PROMO_PRICE = 47.0
export const CF_ALL_ACCESS_YEARLY_MONTHLY_SPLIT_PRICE = 4.99
export const CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE = 3.99
export const CF_ALL_ACCESS_YEARLY_MONTHLY_FULL_PRICE = 29

export const CF_STUDIO_UNLIMITED_YEARLY_PRICE = 29

export const CF_STUDIO_AI_YEARLY_PROMO_PRICE = 59.88
export const CF_STUDIO_AI_YEARLY_PROMO_MONTHLY_SPLIT_PRICE = 4.99
export const VAT_INCLUDED_CF_STUDIO_AI_YEARLY_PROMO_PRICE_NL = 72.45

/**
 * Per-plan definition mirrored from Stripe metadata (keyed by the same lookup keys the backend uses):
 * yearly price (`base` / NL VAT-inclusive `vatInclNl`) and the fixed `coins` grant. The backend does
 * not return the coin grant, so it is mapped here — it stays in sync the same way the price does.
 * `StudioAiYearly` and `StudioAiYearlyV2` intentionally grant the same coin amount.
 */
export const STUDIO_AI_YEARLY_PLANS = {
  [SubscriptionPlan.StudioAiYearly]: { base: 47, vatInclNl: 56.87, coins: 620_000 },
  [SubscriptionPlan.StudioAiYearlyV2]: {
    base: CF_STUDIO_AI_YEARLY_PROMO_PRICE,
    vatInclNl: VAT_INCLUDED_CF_STUDIO_AI_YEARLY_PROMO_PRICE_NL,
    coins: 620_000,
  },
  [SubscriptionPlan.StudioAiYearly7188]: { base: 71.88, vatInclNl: 86.97, coins: 1_000_000 },
  [SubscriptionPlan.StudioAiYearly8388]: { base: 83.88, vatInclNl: 101.49, coins: 1_200_000 },
  [SubscriptionPlan.StudioAiYearly11988]: { base: 119.88, vatInclNl: 145.05, coins: 1_600_000 },
  [SubscriptionPlan.StudioAiYearly14900]: { base: 149, vatInclNl: 180.29, coins: 2_000_000 },
  [SubscriptionPlan.StudioAiYearly19900]: { base: 199, vatInclNl: 240.79, coins: 2_800_000 },
  [SubscriptionPlan.StudioAiYearly29900]: { base: 299, vatInclNl: 361.79, coins: 4_200_000 },
} as const satisfies Partial<
  Record<SubscriptionPlan, { base: number; vatInclNl: number; coins: number }>
>

export const DEFAULT_STUDIO_AI_PLAN = SubscriptionPlan.StudioAiYearlyV2

type StudioAiYearlyPlan = keyof typeof STUDIO_AI_YEARLY_PLANS

export interface StudioAiPlanPrice {
  yearly: number
  monthly: number
}

function roundToCents(amount: number): number {
  return Math.round(amount * 100) / 100
}

function isStudioAiYearlyPlan(plan: SubscriptionPlan | undefined): plan is StudioAiYearlyPlan {
  return plan !== undefined && plan in STUDIO_AI_YEARLY_PLANS
}

function resolveStudioAiPlan(plan: SubscriptionPlan | undefined): StudioAiYearlyPlan {
  return isStudioAiYearlyPlan(plan) ? plan : DEFAULT_STUDIO_AI_PLAN
}

export function getStudioAiPlanPrices(
  plan: SubscriptionPlan | undefined,
  { includeVat }: { includeVat: boolean },
): StudioAiPlanPrice {
  const { base, vatInclNl } = STUDIO_AI_YEARLY_PLANS[resolveStudioAiPlan(plan)]

  const yearly = includeVat ? vatInclNl : base
  const monthly = roundToCents(yearly / 12)

  return { yearly, monthly }
}

/** The fixed coin grant for a plan's 12-month extension (currency- and VAT-independent). */
export function getStudioAiPlanCoins(plan: SubscriptionPlan | undefined): number {
  return STUDIO_AI_YEARLY_PLANS[resolveStudioAiPlan(plan)].coins
}

export const CF_TEAM_MONTHLY_PRICE = 0
export const CF_TEAM_MEMBER_MONTHLY_PRICE = 9.99
export const CF_NL_VAT_RATE = 0.21

export function getNlVatIncludedPrice(price: number): number {
  return roundToCents(price * (1 + CF_NL_VAT_RATE))
}

// oxlint-disable-next-line unicorn/no-zero-fractions
export const CF_ALL_ACCESS_YEARLY_WORTH_VALUE = 348.0
export const CF_COINS_TOP_UP_25K_PRICE_USD = 3.99
export const CF_COINS_TOP_UP_100K_PRICE_USD = 9.99
export const CF_COINS_TOP_UP_250K_PRICE_USD = 19.99
export const CF_COINS_TOP_UP_1000K_PRICE_USD = 69.99

export const YEARLY_EXTENSION_PRICE = CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE
export const YEARLY_FREE_TRIAL_TOTAL_PRICE = 0

// NL VAT Included - Start
export const VAT_INCLUDED_CF_ALL_ACCESS_MONTHLY_PRICE_NL = 10.88
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PRICE_NL = 72.45
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PROMO_PRICE_NL = 56.87
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_MONTHLY_SPLIT_PRICE_NL = 6.04
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_PROMO_MONTHLY_SPLIT_PRICE_NL = 4.74
export const VAT_INCLUDED_CF_ALL_ACCESS_YEARLY_MONTHLY_FULL_PRICE_NL = 35.09
export const VAT_INCLUDED_CF_STUDIO_UNLIMITED_YEARLY_PRICE_NL = 35.09
export const VAT_INCLUDED_CF_COINS_TOP_UP_25K_PRICE_USD = 4.83
export const VAT_INCLUDED_CF_COINS_TOP_UP_100K_PRICE_USD = 12.09
export const VAT_INCLUDED_CF_COINS_TOP_UP_250K_PRICE_USD = 24.19
export const VAT_INCLUDED_CF_COINS_TOP_UP_1000K_PRICE_USD = 84.69

export const VAT_INCLUDED_CF_COIN_PACK_MONTHLY_400K_PRICE_NL = 36.29
export const VAT_INCLUDED_CF_COIN_PACK_MONTHLY_700K_PRICE_NL = 60.49

// NL VAT Included - End
